module.exports = __webpack_public_path__ + "static/media/angry2.7b55ebf8.gif";